export const options = [
  { key: 1, text: "c++", value: 1 },
  { key: 2, text: "Java", value: 2 },
  { key: 3, text: "javascript", value: 3 },
  { key: 4, text: "CSS", value: 4 },
  { key: 5, text: "Html", value: 5},
  { key: 6, text: "Python", value: 6 },
  { key: 7, text: "Golang", value: 7 },
  {key: 8, text:"NodeJS", value:8},
  {key:9, text:"ReactJs", value:9},

];
